<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>

<div class="container-canjes">

    <h2 style="text-align: center;">Solicitud de Canje</h2>
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <form id="enf-canje-add-frm" [formGroup]="canjeSupervisorForm" (ngSubmit)="onSubmit()">
                <div class="row justify-content-left">
                    <label for="fecha" class="mr-2">Fecha *:</label>
                    <p-calendar inputId="fecha" formControlName="fechaInicio" [maxDate]="fechaMaxCanjeHoy"
                        dateFormat="dd/mm/yy" placeholder="Ingrese la fecha" />
                </div>
            </form>
        </ng-template>
        <ng-template pTemplate="right">
            <button form="enf-canje-add-frm" type="submit" label="Solicitar" icon="pi pi-save" class="mr-2" pButton
                [disabled]="canjeSupervisorForm.invalid">
            </button>
        </ng-template>
    </p-toolbar>
    <p-table [value]="casosclinicoscanjear" [(selection)]="selectedCasosClinicos" dataKey="id" [paginator]="true"
        [rows]="5" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrar {first} al {last} de {totalRecords} registros"
        [rowsPerPageOptions]="[5,10,20]" [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Fecha</th>
                <th>Caso Clinico</th>
                <th>Hospital</th>

                <th class="text-right">Puntos</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-casoclinico>
            <tr>
                <td>
                    <p-tableCheckbox [value]="casoclinico"></p-tableCheckbox>
                </td>
                <td>{{casoclinico.fecha}}</td>
                <td>{{casoclinico.serie}}</td>
                <td>{{casoclinico.nomHospital}}</td>

                <td class="text-right">{{casoclinico.s_puntos}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <th colspan="4" class="text-right"></th>
                <th class="text-right">No. Casos Clinicos </th>
                <th class="text-right">{{selectedCasosClinicos.length}}</th>
            </tr>
            <tr>
                <th colspan="4" class="text-right"></th>
                <th class="text-right">Puntos a redimir</th>
                <th class="text-right">{{cantidad}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron casos clinicos</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>